const headerStyle = () => {
  if ($(window).scrollTop() > 50) {
    $('body.home').addClass('page-scrolled');
  } else {
    $('body.home').removeClass('page-scrolled');
  }
};

$(document).on('scroll', function () {
  headerStyle();
});

$(document).ready(function () {
  headerStyle();
});

var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (is_safari) {
  $('body').addClass('is-safari');
}

$(function () {
  $(document).on('click', 'a[href^="#"]', function (e) {
    let offset = 0;
    e.preventDefault();
    let attr = $(this).attr('href');
    let target = $(document.getElementById(attr.replace('#', '')));
    if (!target.length) {
      return;
    }

    $('html, body').animate({
      scrollTop: target.offset().top - offset,
    }, 1000, 'swing' );
  });

  window.scrollTo = function (targetName) {
    const target = $(targetName);

    if (!target.length) {
      return;
    }

    let offset = target.offset().top;
    offset -= $('header').outerHeight();

    $('html, body').animate({
      scrollTop: offset - 0,
    }, 1000);
  };
});

// this will hide the interest button when some specific divs are in view
function checkDivsAndHideButton(divIds, buttonId) {
  var buttonVisible = true;

  divIds.forEach(function(divId) {
    var $div = $('.' + divId);
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    var divTop = $div.offset().top;
    var divBottom = divTop + $div.height();

    if (windowTop <= divBottom && windowBottom >= divTop) {
      // div is in view
      buttonVisible = false;
    }
  });

  if (buttonVisible) {
    // show button
    $('.' + buttonId).addClass('in-view');
  } else {
    // hide button
    $('.' + buttonId).removeClass('in-view');
  }
}

// hide interest button when some divs are in view
if($('.page-cta').length){
  setTimeout(function(){
    checkDivsAndHideButton(['footer'], 'page-cta');
    $(window).scroll(function() {
      checkDivsAndHideButton(['footer'], 'page-cta');
    });
  }, 100);
}
